const monthObj = {
  1: 'Jan',
  2: 'Feb',
  3: 'March',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sept',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
};

const quarterObj = {
  1: ['Jan', 'Feb', 'March'],
  2: ['Apr', 'May', 'Jun'],
  3: ['Jul', 'Aug', 'Sept'],
  4: ['Oct', 'Nov', 'Dec']
};

export const getApiServerUrl = () => {
  let serverUrl = 'http://localhost:9090';
  serverUrl = process.env.REACT_APP_NODE_ENV === 'staging' ? 'https://stagingurl.com' : serverUrl;
  serverUrl = process.env.REACT_APP_NODE_ENV === 'production' ? 'https://productionurl.com' : serverUrl;

  return serverUrl;
};

export function formatNumber(number) {
  if (typeof number === 'number') {
    return Intl.NumberFormat('en-IN', {
      maximumSignificantDigits: 20
    }).format(number);
  }
  return 0;

}


export function findMonthFromFirstQToPreviousQMonths() {
  const quarterObj = {
    1: ['Jan', 'Feb', 'March'],
    2: ['Apr', 'May', 'Jun'],
    3: ['Jul', 'Aug', 'Sept'],
    4: ['Oct', 'Nov', 'Dec']
  };

  const { prevYear,
    // currentYear
  } = findPreviousAndCurrentYear();
  // currentYear = "`" + currentYear.slice(2);
  let q = ((new Date().getMonth() / 3) + 1);
  q = Math.floor(q);
  q -= 1;
  if (q === 0) {
    q = 4;
  }
  const currentQuarterMonths = quarterObj[q];
  const str = `${quarterObj[2][0]}${prevYear}-${currentQuarterMonths[2]}${prevYear}`;
  return str;
}

export function findCurrentQuarterMonths() {
  const quarterObj = {
    1: ['Jan', 'Feb', 'March'],
    2: ['Apr', 'May', 'Jun'],
    3: ['Jul', 'Aug', 'Sept'],
    4: ['Oct', 'Nov', 'Dec']
  };
  let currentYear = new Date().getFullYear().toString();
  currentYear = `'${currentYear.slice(2)}`;
  let q = ((new Date().getMonth() / 3) + 1);
  q = Math.floor(q);
  const currentQuarterMonths = quarterObj[q];
  const str = `${currentQuarterMonths[0]}${currentYear}-${currentQuarterMonths[2]}${currentYear}`;
  return str;
}

export function findPreviousQuarterMonths() {
  const quarterObj = {
    1: ['Jan', 'Feb', 'March'],
    2: ['Apr', 'May', 'Jun'],
    3: ['Jul', 'Aug', 'Sept'],
    4: ['Oct', 'Nov', 'Dec']
  };
  // let currentYear = new Date().getFullYear().toString();
  // currentYear = "`" + currentYear.slice(2);
  const { prevYear,
    // currentYear 
  } = findPreviousAndCurrentYear();
  let q = ((new Date().getMonth() / 3) + 1);
  q = Math.floor(q);
  q -= 1;
  if (q === 0) {
    q = 4;
  }
  const currentQuarterMonths = quarterObj[q];
  const str = `${currentQuarterMonths[0]}${prevYear}-${currentQuarterMonths[2]}${prevYear}`;
  return str;
}


export function findFirstQuarterToCurrentMonths() {

  // let currentYear = new Date().getFullYear().toString();
  const currentMonth = new Date().getMonth() + 1;

  // currentYear = "`" + currentYear.slice(2);
  const { prevYear, currentYear } = findPreviousAndCurrentYear();
  // let q = ((new Date().getMonth() / 3) + 1);
  // q = Math.floor(q);
  // let currentQuarterMonths = quarterObj[q];
  const str = `${quarterObj[2][0]}${prevYear}-${monthObj[currentMonth]}${currentYear}`;
  return str;
}

export function getCurrentMonth() {
  const date = new Date();
  const month = date.getMonth() + 1;
  let year = date.getFullYear().toString();
  year = getYearString(year);
  return `${monthObj[month]}${year}`;
}


export function getCurrentQuarterMonths() {
  let q = ((new Date().getMonth() / 3) + 1);
  q = Math.floor(q);
  const date = new Date();
  const month = date.getMonth() + 1;
  let year = date.getFullYear().toString();
  year = getYearString(year);

  return `${quarterObj[q][0]}${year}-${monthObj[month]}${year}`;
}

export function formatDate(date) {
  date = new Date(date);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear().toString();
  year = getYearString(year);
  if (day < 10) {
    day = '0' + day;
  }
  month = monthObj[month];
  return `${day} ${month}${year}`;
}

export function getYearString(year) {
  if (!year) {
    year = new Date().getFullYear().toString();
  }
  return `'${year.slice(2)}`;
}

function findPreviousAndCurrentYear() {
  let currentYear = '';
  let prevYear = '';
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  currentYear = new Date().getFullYear();
  prevYear = new Date().getFullYear();
  if (currentMonth < 4) {
    prevYear = currentYear - 1;
  }

  prevYear = prevYear.toString();
  currentYear = currentYear.toString();
  prevYear = getYearString(prevYear);
  currentYear = getYearString(currentYear);
  return { prevYear, currentYear };
}

/**
 * Get token from localStorage and make it bearer token
 */
export const getHeaders = () => {
  const { token } = localStorage;
  const headers = { Authorization: `bearer ${token}` };
  return headers;
};

export function downlodFile(url) {
  // let blob = new Blob([b.data], { type: b.headers['content-type'] });
  // const url = URL.createObjectURL(blob, {});
  // const url = b.data.data.file;
  // const url = window.URL.createObjectURL(new Blob([b]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'sample.xlsx');
  link.setAttribute('target', '_blank');
  // 3. Append to html page
  document.body.appendChild(link);
  // 4. Force download
  link.click();
  // 5. Clean up and remove the link
  link.parentNode.removeChild(link);
}

/**
 * Common api handler. e.g. after every api error response you can check status code. if status code is 423 means token is expired and you can redirect user to login page
 * @param {Object} error api error object
 */
export const handleApiError = error => {
  // common api error handler
  const err = JSON.parse(JSON.stringify(error));
  if (
    err &&
    err.response &&
    err.response.status &&
    err.response.status === 423
  ) {
    // if user session is expired we will clear the storage
    // and redirect user to login page
    localStorage.clear();
    window.location.replace('/#/login');
    return {};
  }
  throw error;
};

export function getScreenResolution() {
  return `${window.screen.availWidth}x${window.screen.availHeight}`
}

export function generateRandomString() {
  return Math.random()
    .toString(36)
    .substring(2);
}


const utils = {
  getHeaders,
  handleApiError,
  getApiServerUrl,
  generateRandomString,
};

export default utils;
